//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register"

//LOGIN
export const POST_FAKE_LOGIN = "/post-fake-login"
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login"
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd"
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd"
export const SOCIAL_LOGIN = "/social-login"

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile"
export const POST_EDIT_PROFILE = "/post-fake-profile"

// AUTH
export const LOGIN_URL = "api/v1/account/auth/login"
export const FORGOT_PASSWORD = "api/v1/account/auth/forgot-password"
export const OTP_VERIFICATION = "api/v1/account/auth/verify-forgot-password-otp"
export const CHANGE_PASSWORD = "api/v1/account/auth/change-password"
export const GET_PROFILE_DETAILS = "api/v1/profile"

// JOB APPLICATION
export const GET_JOB_APPLICATION = "api/v1/admin/candidate/list"
export const GET_JOB_APPLICATION_DETAILS = "api/v1/profile"
export const GET_AVAILABLE_SLOTS = "/api/v1/profile/interview/available-slots"
export const INTERVIEW_APPLY = "/api/v1/profile/interview/apply"

// INTERVIEW SCHEDULE MANAGEMENT
export const GET_INTERVIEW_SCHEDULE_LIST =
  "api/v1/admin/interview/schedule/list"
export const CREATE_INTERVIEW_SCHEDULE = "api/v1/admin/interview/schedule/store"
export const GET_MATCHED_CANDIDATES_LIST = "api/v1/admin/candidate/search"
export const WITHDRAWN_JOB_APPLICATION =
  "api/v1/profile/job-application/withdrawn"
export const JOB_APPLICATION_TIMELINE =
  "api/v1/profile/job-application/timeline"
export const CANCEL_INTERVIEW = "api/v1/profile/interview/cancel"
export const VERIFY_ACTION_OTP = "api/v1/account/auth/verify-action-otp"

// INTERVIEW
export const ASSESSMENT_LIST = "/api/v1/admin/interview/assessment/list"
export const GET_INTERVIEW_QUESTIONS = "/api/v1/admin/interview/questions"
export const GET_JOB_TITLES = "/api/v1/common/form-dropdown/job-titles"
export const SUBMIT_INTERVIEW_ASSESSMENT =
  "/api/v1/admin/interview/assessment/submit"

// COMMON
export const GET_DROPDOWN_API = "api/v1/common/form-dropdown/lists?type=all"

// BOOKINGS
export const GET_ALL_BOOKINGS = "bookings/admins/v1/bookings/getBookings"
export const GET_BOOKING_DETAILS = "bookings/admins/v1/bookings/details"
export const UPDATE_BOOKING_STATUS =
  "bookings/admins/v1/bookings/updateBookingStatus"
export const UPDATE_PAYMENT_CONTRACT_OR_LETTER =
  "bookings/admins/v1/bookings/uploadContractOrLetter"
export const UPLOAD_DEED_DOCUMENTS =
  "bookings/admins/v1/bookings/uploadDeedDocuments"
